export type AdminEventSubjectKind =
  | "order"
  | "script"
  | "scriptReview"
  | "submission"
  | "vendor"
  | "import"
  | "email";

export interface AdminEventSubject {
  kind: AdminEventSubjectKind;
  id: string;
}

function asRecord(value: unknown): Record<string, unknown> | null {
  if (value !== null && typeof value === "object" && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return null;
}

export function readAdminEventSubject(
  payload: Record<string, unknown> | null | undefined,
  attributes?: Record<string, unknown> | null,
): AdminEventSubject | null {
  const fromPayload = asRecord(payload?.subject);
  const kind =
    (typeof fromPayload?.kind === "string" && fromPayload.kind) ||
    (typeof attributes?.subjectKind === "string" && attributes.subjectKind) ||
    null;
  const id =
    (typeof fromPayload?.id === "string" && fromPayload.id) ||
    (typeof attributes?.subjectId === "string" && attributes.subjectId) ||
    null;
  if (!kind || !id) return null;
  return { kind: kind as AdminEventSubjectKind, id };
}

export function readAdminEventOutcome(
  payload: Record<string, unknown> | null | undefined,
  attributes?: Record<string, unknown> | null,
  status?: string,
): "success" | "failed" | "skipped" | null {
  const raw =
    (typeof payload?.outcome === "string" && payload.outcome) ||
    (typeof attributes?.outcome === "string" && attributes.outcome) ||
    null;
  if (raw === "success" || raw === "failed" || raw === "skipped") return raw;
  if (status === "FAILED") return "failed";
  if (status === "COMPLETED") return "success";
  return null;
}

export function adminEventSubjectHref(subject: AdminEventSubject): string | null {
  switch (subject.kind) {
    case "order":
    case "script":
    case "submission":
      return "/marketplace/orders";
    case "scriptReview":
      return `/pre-flight-scripts/review/${subject.id}`;
    case "vendor":
      return "/marketplace/admin";
    case "import":
      return "/marketplace/import";
    default:
      return null;
  }
}
